import React, { useEffect, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Form, Row, Col } from "react-bootstrap";
import noimage from "../../assets/img/noimage.png";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config/config";
import { toast } from "react-toastify";
import { netWorkAdd, netWorkEdit } from "../../Actions/axios";
import { isEmpty } from "../../Actions/common";

const NetworkEdit = () => {
  const location = useLocation();
  const [data, setData] = useState({
    rpc : [""]
  });
  const [err, setErr] = useState({});
  console.log("🚀 ~ NetworkEdit ~ data:", data);
  const navigate = useNavigate();

  const onChangeFunc = (e, i) => {
    var { name, value, files } = e.target;
    console.log("🚀 ~ onChangeFunc ~ e.target:", e.target);
    if (name == "rpc") {
      let temp = data.rpc;
      temp[i] = value;
      setData({ ...data, [name]: temp });
    } else {
      setData({ ...data, [name]: files ? files[0] : value });
    }
  };
  const validataion = async () => {
    let err = {};
    await Promise.all(
      Object.keys(data)?.map((val) => {
        console.log(val, data[val], data[val]?.name, isEmpty(data[val]?.name));
        if (val == "files" || val == "rpc") {
          if (val == "files" && isEmpty(data[val]?.name)) {
            err[val] = `${val} is required`;
          }
          if (val == "rpc") {
            if (data[val]?.some((val) => val == "")) {
              err[val] = `${val} is Required`;
            }
          }
        } else {
          if (isEmpty(data[val])) {
            err[val] = `${val} is required`;
          }
        }
      })
    );
    setErr(err);
    return err;
  };

  const AddNetworkData = async () => {
    let err = await validataion();
    console.log("🚀 ~ EditNetworkData ~ err:", err);
    if (!isEmpty(err)) {
      return toast.error("Field Required");
    }
    let resp = await netWorkAdd(data);
    console.log("🚀 ~ EditNetworkData ~ resp:", resp);
    if (resp?.status) {
      toast.success(resp?.message);
      navigate("/networklist");
    } else {
      toast.error(resp?.message);
    }
  };

  const removeRpc = (i) => {
    let temp = data?.rpc;
    temp.splice(i, 1);
    console.log("temp.rpc-->", temp.rpc, temp);
    setData({ ...data, ["rpc"]: temp });
  };


  return (
    <>
      <div className="cmsedit">
        <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
          Back
        </button>
        <h1 className="pagehead">Network Details</h1>
        <div className="cardbox">
          <Form>
            <Row>
              <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    onChange={onChangeFunc}
                    value={data?.name}
                  />
                  {err?.name && <p className="error_msg">{err?.name}</p>}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                <Form.Group>
                  <Form.Label>Symbol</Form.Label>
                  <Form.Control
                    type="text"
                    name="symbol"
                    onChange={onChangeFunc}
                    value={data?.symbol}
                  />
                  {err?.symbol && <p className="error_msg">{err?.symbol}</p>}
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                <Form.Group>
                  <Form.Label>RPC</Form.Label>
                  {data?.rpc?.map((val, i) => (
                    <>
                      <Form.Control
                        value={val}
                        name="rpc"
                        onChange={(e) => onChangeFunc(e, i)}
                        type="text"
                      />
                      {data?.rpc?.length - 1 == i ? (
                        <button
                          className="btn sitebtn mt-2 mb-2"
                          type="button"
                          onClick={() =>
                            setData({ ...data, ["rpc"]: [...data?.rpc, ""] })
                          }
                        >
                          ADD
                        </button>
                      ) : (
                        <button
                          className="btn sitebtn mt-2 mb-2"
                          type="button"
                          onClick={() => removeRpc(i)}
                        >
                          Remove
                        </button>
                      )}
                    </>
                  ))}
                  {err?.rpc && <p className="error_msg">{err?.rpc}</p>}
                  {/* <F
                  orm.Control type="text" /> */}
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} className="mb-4">
                <Form.Group>
                  <Form.Label>Image</Form.Label>
                  <div className="uploadimgbox">
                    <img
                      src={
                        data?.files
                          ? URL.createObjectURL(data?.files)
                          : `${config.Back_URL}network/${data?.logo}`
                      }
                      alt="user"
                      className="img-fluid"
                    />
                    <Form.Control
                      type="file"
                      name="files"
                      onChange={onChangeFunc}
                    />
                  </div>
                </Form.Group>
              </Col>
             
            </Row>
          </Form>
          <button
            type="button"
            onClick={() => {
                AddNetworkData();
            }}
            className="btn sitebtn py-2 px-3 mt-4"
          >
            ADD
          </button>
        </div>
      </div>
    </>
  );
};

export default NetworkEdit;
